import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { isEmpty } from 'lodash'
import { Col, Modal, Row, Select, Tooltip } from 'antd'
import {
  CheckboxLabel,
  EduIf,
  RadioBtn,
  SelectInputStyled,
} from '@edulastic/common'
import { themeColor } from '@edulastic/colors'
import { roleuser, test } from '@edulastic/constants'
import {
  TEST_CONTENT_VISIBILITY,
  evalTypeLabels,
  testCategoryTypes,
  testContentVisibility as testContentVisibilityOptions,
} from '@edulastic/constants/const/test'
import { multipartEvaluationTypes } from '@edulastic/constants/const/evaluationType'
import { withNamespaces } from '@edulastic/localization'
import { TEST_TYPE_SURVEY } from '@edulastic/constants/const/testTypes'
import { compose } from 'redux'
import { connect } from 'react-redux'
import {
  AlignRight,
  AlignSwitchRight,
  AssignModuleContentSpan,
  CheckBoxWrapper,
  Label,
  StyledCol,
  StyledRow,
  TimeSpentInput,
} from '../SimpleOptions/styled'
import TestTypeSelector from '../SimpleOptions/TestTypeSelector'
import DollarPremiumSymbol from './DollarPremiumSymbol'
import DetailsTooltip from './DetailsTooltip'
import SettingContainer from './SettingsContainer'
import {
  showRubricToStudentsSetting,
  showAutoEssayEvaluationSetting,
} from '../../../TestPage/utils'
import RefMaterialFile from './RefMaterialFile'
import ShowHintsToStudents from './ShowHintsToStudents'
import CalculatorSettings, {
  CalculatorDetailsTooltip,
} from '../../../Shared/Components/CalculatorSettings'
import ContentVisibilityOptions from '../../../TestPage/components/Setting/components/Common/ContentVisibilityOptions'
import { BetaTag2 } from '../../../../common/components/BetaTag'
import HelperToolTip from '../../../../assessment/components/EvaluationSettings/components/HelperToolTip'
import { isPearDomain } from '../../../../../utils/pear'
import {
  edulasticText,
  pearAssessmentText,
} from '../../../../common/utils/helpers'
import PlayerSkinSelector from '../SimpleOptions/PlayerSkinSelector'
import {
  getCurrentSchoolState,
  getTestTypesFormatedConstant,
  getUserTestTypes,
} from '../../../src/selectors/user'

const {
  releaseGradeTypes,
  evalTypes,
  completionTypes,
  releaseGradeLabels,
  playerSkinValues,
} = test

const TEST_TYPE_TOOLTIP_CONTENT =
  'Designate what type of assignment you are delivering. You’ll be able to use these categories later to filter reports so make sure practice is set as practice. '

const ASSIGN_MODULE_TOOLTIP_CONTENT =
  'If freeze settings is enabled in any of the test(s) in this module, then the assignment settings will default to the test settings for the respective tests.'

const TestBehaviorGroupContainer = ({
  assignmentSettings,
  changeField,
  testSettings,
  _releaseGradeKeys,
  freezeSettings,
  completionTypeKeys,
  premium,
  overRideSettings,
  match,
  totalItems,
  userRole,
  featuresAvailable,
  tootltipWidth,
  showAssignModuleContent,
  t: i18translate,
  allowToUseShowHintsToStudents,
  togglePenaltyOnUsingHints,
  isAiEvaulationDistrict,
  isSectionAdaptiveTest,
  disableAnswerOnPaper,
  allTestTypesInternal,
  userTestTypesInternal,
  districtState,
}) => {
  const { COMMON } = allTestTypesInternal

  const [timedTestConfirmed, setTimedtestConfirmed] = useState(false)
  const {
    markAsDone = testSettings?.markAsDone,
    releaseScore = testSettings.releaseScore,
    calcTypes = testSettings.calcTypes,
    timedAssignment = testSettings.timedAssignment,
    allowedTime = testSettings.allowedTime,
    pauseAllowed = testSettings.pauseAllowed,
    testType = testSettings.testType,
    playerSkinType = testSettings.playerSkinType || playerSkinValues.edulastic,
    applyEBSR = false,
    showRubricToStudents = testSettings.showRubricToStudents,
    allowAutoEssayEvaluation = testSettings.allowAutoEssayEvaluation,
    allowTeacherRedirect = testSettings.allowTeacherRedirect,
    referenceDocAttributes = testSettings?.referenceDocAttributes,
    isDocBased = testSettings?.isDocBased,
    showHintsToStudents = testSettings?.showHintsToStudents,
    penaltyOnUsingHints = testSettings?.penaltyOnUsingHints,
    testContentVisibility = testSettings?.testContentVisibility,
    vqPreventSkipping = testSettings?.vqPreventSkipping,
    vqEnableClosedCaption = testSettings?.vqEnableClosedCaption,
    vqEnableSpeedControl = testSettings?.vqEnableSpeedControl,
    isTestContentRestrictedBySuperAdmin = testSettings?.isTestContentRestrictedBySuperAdmin,
    answerOnPaper = testSettings.answerOnPaper,
  } = assignmentSettings

  const showRefMaterial = !isDocBased
  const multipartItems = testSettings.itemGroups
    .map((o) => o.items)
    .flat()
    .filter((o) => o.multipartItem).length
  const {
    assessmentSuperPowersMarkAsDone,
    assessmentSuperPowersShowCalculator,
    assessmentSuperPowersTimedTest,
    assessmentSuperPowersAnswerOnPaper,
    selectPlayerSkinType,
  } = featuresAvailable

  const isShowRubricToStudentsSettingVisible = showRubricToStudentsSetting(
    testSettings.itemGroups
  )

  const isShowAutoEssayEvaluationSetting = showAutoEssayEvaluationSetting(
    testSettings.itemGroups
  )
  const scoringType =
    assignmentSettings?.scoringType ||
    testSettings?.scoringType ||
    evalTypes?.ITEM_LEVEL_EVALUATION

  useEffect(() => {
    if (!COMMON.includes(testType))
      overRideSettings(
        TEST_CONTENT_VISIBILITY,
        testContentVisibilityOptions.ALWAYS
      )
  }, [testType])

  const updateTimedTestAttrs = (attr, value) => {
    if (
      match?.params?.assignmentId &&
      match?.params?.classId &&
      !timedTestConfirmed
    ) {
      Modal.confirm({
        title: 'Do you want to Proceed ?',
        content:
          'Changes made in Timed Assignment will impact all Students who are In Progress or Not Started.',
        onOk: () => {
          if (attr === 'timedAssignment' && value) {
            overRideSettings('pauseAllowed', true)
            overRideSettings('allowedTime', totalItems * 60 * 1000)
          }
          overRideSettings(attr, value)
          setTimedtestConfirmed(true)
          Modal.destroyAll()
        },
        onCancel: () => {},
        okText: 'Proceed',
        centered: true,
        width: 500,
        okButtonProps: {
          style: { background: themeColor },
        },
      })
      return
    }
    if (attr === 'timedAssignment' && value) {
      overRideSettings('pauseAllowed', true)
      overRideSettings('allowedTime', totalItems * 60 * 1000)
    }

    overRideSettings(attr, value)
  }

  const updateRefMaterials = (value) => {
    overRideSettings('referenceDocAttributes', value)
  }

  const testTypeContent = (
    <>
      <span>{TEST_TYPE_TOOLTIP_CONTENT} </span>
      {showAssignModuleContent && (
        <AssignModuleContentSpan>
          {ASSIGN_MODULE_TOOLTIP_CONTENT}
        </AssignModuleContentSpan>
      )}
    </>
  )

  const warningText = `(${i18translate('rubric.infoText')})`

  const isTestlet = playerSkinType?.toLowerCase() === playerSkinValues.testlet

  const isVideoQuiz =
    testSettings.testCategory === testCategoryTypes.VIDEO_BASED

  return (
    <>
      {/* Test type */}
      <SettingContainer
        id="test-type-setting"
        tooltipId="test-type-setting-tooltip"
      >
        <DetailsTooltip
          width={tootltipWidth}
          title="Test Type"
          content={testTypeContent}
          premium
          placement="rightBottom"
          id="test-type-setting-tooltip"
        />
        <StyledRow mb="15px" gutter={16}>
          <TestTypeSelector
            userRole={userRole}
            testType={testType}
            onAssignmentTypeChange={changeField('testType')}
            disabled={freezeSettings || testType === TEST_TYPE_SURVEY}
          />
        </StyledRow>
      </SettingContainer>
      {/* Test type */}
      {/* Prevent Skipping */}
      <EduIf
        condition={testSettings.testCategory === testCategoryTypes.VIDEO_BASED}
      >
        <SettingContainer
          id="vq-prevent-skipping"
          tooltipId="vq-prevent-skipping-tooltip"
        >
          <DetailsTooltip
            width={tootltipWidth}
            title="Prevent Skipping"
            content=" If ON, Students won't be able to skip ahead in a video."
            placement="rightTop"
            premium={premium}
            id="vq-prevent-skipping-tooltip"
          />
          <StyledRow gutter={16} mb="15px">
            <Col span={10}>
              <Label>Prevent Skipping</Label>
            </Col>
            <Col span={14}>
              <AlignSwitchRight
                disabled={freezeSettings}
                size="small"
                checked={vqPreventSkipping}
                data-cy="vqPreventSkipping"
                onChange={(value) =>
                  overRideSettings('vqPreventSkipping', value)
                }
              />
            </Col>
          </StyledRow>
        </SettingContainer>

        {/* Prevent Skipping */}
        {/* Enable vq CC start */}

        <SettingContainer id="vq-enable-cc" tooltipId="vq-enable-cc-tooltip">
          <DetailsTooltip
            width={tootltipWidth}
            title="Turn on closed captions"
            content="Enable closed captions if available for YouTube videos."
            placement="rightTop"
            premium={premium}
            id="vq-enable-cc-tooltip"
          />
          <StyledRow gutter={16} mb="15px">
            <Col span={10}>
              <Label>Turn on closed captions</Label>
            </Col>
            <Col span={14}>
              <AlignSwitchRight
                disabled={freezeSettings}
                size="small"
                checked={vqEnableClosedCaption}
                data-cy="vqEnableClosedCaption"
                onChange={(value) =>
                  overRideSettings('vqEnableClosedCaption', value)
                }
              />
            </Col>
          </StyledRow>
        </SettingContainer>
        <SettingContainer id="vq-enable-sp" tooltipId="vq-enable-sp-tooltip">
          <DetailsTooltip
            width={tootltipWidth}
            title="Speed up videos"
            content="Allow students to watch videos at 1.25, 1.5, 1.75, or 2 times their normal speed (students can always slow down videos)."
            placement="rightTop"
            premium={premium}
            id="vq-enable-sp-tooltip"
          />
          <StyledRow gutter={16} mb="15px">
            <Col span={10}>
              <Label>Speed up videos</Label>
            </Col>
            <Col span={14}>
              <AlignSwitchRight
                disabled={freezeSettings}
                size="small"
                checked={vqEnableSpeedControl}
                data-cy="vqEnableSpeedControl"
                onChange={(value) =>
                  overRideSettings('vqEnableSpeedControl', value)
                }
              />
            </Col>
          </StyledRow>
        </SettingContainer>
      </EduIf>
      {/* Enable vq CC ends */}
      {/* Release score */}
      <SettingContainer
        id="release-score-setting"
        tooltipId="release-score-tooltip"
      >
        <DetailsTooltip
          width={tootltipWidth}
          title="RELEASE SCORES"
          content="Decide what students immediately get to see upon submitting an assessment."
          premium
          placement="rightTop"
          id="release-score-tooltip"
        />
        <StyledRow gutter={16} mb="15px">
          <Col span={10}>
            <Label>
              RELEASE SCORES{' '}
              {releaseScore === releaseGradeLabels.DONT_RELEASE
                ? '[OFF]'
                : '[ON]'}
            </Label>
          </Col>
          <StyledCol span={14}>
            <SelectInputStyled
              data-cy="selectRelaseScore"
              placeholder="Please select"
              cache="false"
              value={releaseScore}
              onChange={changeField('releaseScore')}
              height="30px"
            >
              {_releaseGradeKeys.map((item, index) => (
                <Select.Option key={index} value={item}>
                  {releaseGradeTypes[item]}
                </Select.Option>
              ))}
            </SelectInputStyled>
          </StyledCol>
        </StyledRow>
      </SettingContainer>
      {/* Release score */}
      {/* Evaluation Method */}
      <SettingContainer
        id="evaluation-method-setting"
        tooltipId="evaluation-method-tooltip"
      >
        <DetailsTooltip
          width={tootltipWidth}
          title="EVALUATION METHOD"
          content="Choose if students should be awarded partial credit for their answers or not. If partial credit is allowed, then choose whether the student should be penalized for incorrect answers or not (applicable only for multiple selection question widgets)."
          premium
          id="evaluation-method-tooltip"
        />
        <StyledRow gutter={16} mb="15px">
          <Col span={10}>
            <Label>EVALUATION METHOD</Label>
          </Col>
          <StyledCol span={14}>
            <SelectInputStyled
              data-cy="eval-methods"
              disabled={freezeSettings || testType === TEST_TYPE_SURVEY}
              onChange={(value) => {
                if (!freezeSettings) {
                  overRideSettings('scoringType', value)
                }
              }}
              value={scoringType}
              height="30px"
            >
              {Object.keys(evalTypes).map((evalKey, index) => (
                <Select.Option value={evalKey} data-cy={evalKey} key={evalKey}>
                  {Object.values(evalTypes)[index]}
                </Select.Option>
              ))}
            </SelectInputStyled>
            {(scoringType === evalTypeLabels.PARTIAL_CREDIT ||
              scoringType === evalTypeLabels.PARTIAL_CREDIT_IGNORE_INCORRECT) &&
            multipartItems &&
            premium ? (
              <CheckBoxWrapper>
                <CheckboxLabel
                  disabled={freezeSettings}
                  data-cy="applyEBSR"
                  checked={applyEBSR}
                  onChange={(e) =>
                    overRideSettings('applyEBSR', e.target.checked)
                  }
                >
                  <StyledSpan>
                    APPLY EBSR GRADING
                    <HelperToolTip
                      optionKey={multipartEvaluationTypes.FIRST_CORRECT_MUST}
                      placement="topLeft"
                      isMultipartSetting
                    />
                  </StyledSpan>
                </CheckboxLabel>
              </CheckBoxWrapper>
            ) : null}
          </StyledCol>
        </StyledRow>
      </SettingContainer>
      {/* Evaluation Method */}

      {/* Mark as done */}
      {!isVideoQuiz && (
        <SettingContainer
          id="mark-as-done-setting"
          tooltipId="mark-as-done-tooltip"
        >
          <DetailsTooltip
            width={tootltipWidth}
            title="Mark as done"
            content="When an assignment is marked “Done”, data flows to the reports. Automatically will mark it as done when all students are graded and the due date has passed, OR choose Manually and select the Mark as Done button when ready."
            premium={assessmentSuperPowersMarkAsDone}
            id="mark-as-done-tooltip"
          />
          <StyledRow gutter={16} mb="15px">
            <Col span={10}>
              <Label>
                MARK AS DONE
                <DollarPremiumSymbol
                  premium={assessmentSuperPowersMarkAsDone}
                />
              </Label>
            </Col>
            <StyledCol span={14}>
              <AlignRight
                disabled={freezeSettings || !assessmentSuperPowersMarkAsDone}
                onChange={(e) => overRideSettings('markAsDone', e.target.value)}
                value={markAsDone}
              >
                {completionTypeKeys.map((item) => (
                  <RadioBtn
                    value={completionTypes[item]}
                    data-cy={`mark-as-done-${completionTypes[item]}`}
                    key={item}
                  >
                    <Label>{completionTypes[item]}</Label>
                  </RadioBtn>
                ))}
              </AlignRight>
            </StyledCol>
          </StyledRow>
        </SettingContainer>
      )}
      {/* Mark as done */}

      {/* Show Calculator */}
      <SettingContainer
        id="calculator-setting"
        tooltipId="calculator-setting-tooltip"
      >
        <DetailsTooltip
          width={tootltipWidth}
          title="SHOW CALCULATOR"
          content={<CalculatorDetailsTooltip count={calcTypes.length} />}
          premium={assessmentSuperPowersShowCalculator}
          id="calculator-setting-tooltip"
        />
        <StyledRow gutter={16} mb="15px">
          <Col span={10}>
            <Label>
              SHOW CALCULATOR (Desmos)
              <DollarPremiumSymbol
                premium={assessmentSuperPowersShowCalculator}
              />
            </Label>
          </Col>
          <StyledCol span={14}>
            <CalculatorSettings
              disabled={freezeSettings || !assessmentSuperPowersShowCalculator}
              value={calcTypes}
              onChange={(value) => overRideSettings('calcTypes', value)}
            />
          </StyledCol>
        </StyledRow>
      </SettingContainer>
      {/* Show Calculator */}

      {/* Reference Material */}
      <EduIf condition={showRefMaterial}>
        <RefMaterialFile
          premium={premium}
          disabled={freezeSettings}
          tootltipWidth={tootltipWidth}
          setData={updateRefMaterials}
          referenceDocAttributes={referenceDocAttributes}
          hasAttributesInTest={!isEmpty(testSettings?.referenceDocAttributes)}
        />
      </EduIf>

      {/* Reference Material */}

      {/* Timed TEST */}
      {!isSectionAdaptiveTest && !isVideoQuiz && (
        <SettingContainer
          id="timed-test-setting"
          tooltipId="timed-test-setting-tooltip"
        >
          <DetailsTooltip
            width={tootltipWidth}
            title="TIMED TEST"
            content="Timed test allows you to control how long students have to take the test. When the time limit is reached, students will be locked out of the assessment. Choose the time and whether students can pause and continue later or if the test should be taken in a single sitting."
            premium={assessmentSuperPowersTimedTest}
            placement="rightTop"
            id="timed-test-setting-tooltip"
          />
          <StyledRow
            data-cy="timed-test-container"
            gutter={16}
            mb="15px"
            height="40"
            noWrap
          >
            <Col span={10}>
              <Label>
                <span>
                  TIMED TEST
                  <DollarPremiumSymbol
                    premium={assessmentSuperPowersTimedTest}
                  />
                </span>
              </Label>
            </Col>
            <Col span={10} style={{ display: 'flex', flexDirection: 'column' }}>
              <Row style={{ display: 'flex', alignItems: 'center' }}>
                <AlignSwitchRight
                  data-cy="assignment-time-switch"
                  size="small"
                  defaultChecked={false}
                  disabled={freezeSettings || !assessmentSuperPowersTimedTest}
                  checked={timedAssignment}
                  onChange={(value) =>
                    updateTimedTestAttrs('timedAssignment', value)
                  }
                  aria-label={`Timed Test ${
                    timedAssignment ? 'enabled' : 'disabled'
                  }`}
                />
                {timedAssignment && (
                  <>
                    {/* eslint-disable no-restricted-globals */}
                    <TimeSpentInput
                      onChange={(e) => {
                        if (
                          e.target.value.length <= 3 &&
                          e.target.value <= 300
                        ) {
                          updateTimedTestAttrs(
                            'allowedTime',
                            e.target.value * 60 * 1000
                          )
                        }
                      }}
                      size="large"
                      data-cy="assignment-time"
                      value={
                        !isNaN(allowedTime)
                          ? allowedTime / (60 * 1000) || ''
                          : 1
                      }
                      type="number"
                      min={1}
                      max={300}
                      step={1}
                    />
                    <Label>MINUTES</Label>
                    {/* eslint-enable no-restricted-globals */}
                  </>
                )}
              </Row>
              <Row>
                {timedAssignment && (
                  <CheckBoxWrapper>
                    <CheckboxLabel
                      disabled={
                        freezeSettings || !assessmentSuperPowersTimedTest
                      }
                      data-cy="exit-allowed"
                      checked={pauseAllowed}
                      onChange={(e) =>
                        updateTimedTestAttrs('pauseAllowed', e.target.checked)
                      }
                    >
                      <span>Allow student to save and continue later</span>
                    </CheckboxLabel>
                  </CheckBoxWrapper>
                )}
              </Row>
            </Col>
          </StyledRow>
        </SettingContainer>
      )}

      {/* Timed TEST */}

      {!testSettings?.isDocBased && (
        <SettingContainer
          id="show-rubric-to-students"
          tooltipId="show-rubric-to-students-tooltip"
        >
          <DetailsTooltip
            width={tootltipWidth}
            title="SHOW RUBRIC TO STUDENTS"
            content={i18translate('showRubricToStudents.info')}
            premium={premium}
            placement="rightTop"
            id="show-rubric-to-students-tooltip"
          />
          <StyledRow
            data-cy="show-rubric-to-students-container"
            gutter={16}
            mb="15px"
            height="40"
            noWrap
          >
            <Col span={10}>
              <Label>
                <span>SHOW RUBRIC TO STUDENTS</span>
                <DollarPremiumSymbol premium={premium} />
              </Label>
            </Col>
            <Col span={10} style={{ display: 'flex', flexDirection: 'column' }}>
              <Row style={{ display: 'flex', alignItems: 'center' }}>
                <AlignSwitchRight
                  data-cy="show-rubric-to-students-switch"
                  size="small"
                  defaultChecked={false}
                  disabled={
                    !isShowRubricToStudentsSettingVisible ||
                    freezeSettings ||
                    !premium
                  }
                  checked={showRubricToStudents}
                  onChange={(value) =>
                    overRideSettings('showRubricToStudents', value)
                  }
                  aria-label={`Show Rubric To Students ${
                    showRubricToStudents ? 'enabled' : 'disabled'
                  }`}
                />
              </Row>
            </Col>
          </StyledRow>
        </SettingContainer>
      )}
      <EduIf
        condition={[
          isShowAutoEssayEvaluationSetting,
          !testSettings?.isDocBased,
          isAiEvaulationDistrict,
        ].every((o) => !!o)}
      >
        <SettingContainer
          id="auto-essay-evaluation"
          tooltipId="auto-essay-evaluation-tooltip"
        >
          <DetailsTooltip
            width={tootltipWidth}
            title={i18translate('allowAutoEssayEvaluation.title')}
            content={i18translate('allowAutoEssayEvaluation.info')}
            premium={premium}
            placement="rightTop"
            warningText={warningText}
            id="auto-essay-evaluation-tooltip"
          />
          <StyledRow gutter={16} mb="15px" height="40" noWrap>
            <Col span={10}>
              <Label>
                <span>
                  {i18translate('allowAutoEssayEvaluation.autoEssayEvaluation')}
                  <br />
                  {i18translate('allowAutoEssayEvaluation.essayQuestion')}
                </span>
                <BetaTag2 mt="-35px" ml="4px">
                  BETA
                </BetaTag2>
                <DollarPremiumSymbol premium={premium} />
              </Label>
            </Col>
            <Col span={10} style={{ display: 'flex', flexDirection: 'column' }}>
              <Row style={{ display: 'flex', alignItems: 'center' }}>
                <AlignSwitchRight
                  data-cy="auto-essay-evaluation"
                  size="small"
                  defaultChecked={false}
                  disabled={freezeSettings || !premium}
                  checked={allowAutoEssayEvaluation}
                  onChange={(value) =>
                    overRideSettings('allowAutoEssayEvaluation', value)
                  }
                />
              </Row>
            </Col>
            <Col
              span={24}
              style={{ marginTop: '8px', fontStyle: 'italic' }}
              data-cy="auto-essay-evaluation-future-only"
            >
              {i18translate('allowAutoEssayEvaluation.futureOnly')}
            </Col>
          </StyledRow>
        </SettingContainer>
      </EduIf>
      {/* Show hints to students */}
      {!(isDocBased && isTestlet) && (
        <SettingContainer
          id="show-hints-to-students"
          tooltipId="show-hints-to-students-tooltip"
        >
          <DetailsTooltip
            width={tootltipWidth}
            title="SHOW HINTS TO STUDENTS"
            content="Students will be able to see the hint associated with an item while attempting the assignment"
            premium={premium}
            placement="rightTop"
            id="show-hints-to-students-tooltip"
          />
          <ShowHintsToStudents
            tootltipWidth={tootltipWidth}
            premium={premium}
            freezeSettings={freezeSettings}
            showHintsToStudents={showHintsToStudents}
            penaltyOnUsingHints={penaltyOnUsingHints}
            overRideSettings={overRideSettings}
            allowToUseShowHintsToStudents={allowToUseShowHintsToStudents}
            togglePenaltyOnUsingHints={togglePenaltyOnUsingHints}
          />
        </SettingContainer>
      )}
      {/* Show hints to students */}

      {/* Test Content visibility */}
      {COMMON.includes(testType) &&
        (userRole === roleuser.DISTRICT_ADMIN ||
          userRole === roleuser.SCHOOL_ADMIN) && (
          <SettingContainer
            id="content-visibility"
            tooltipId="content-visibility-tooltip"
          >
            <DetailsTooltip
              width={tootltipWidth}
              title="TEST CONTENT VISIBILITY"
              content="Should teachers see the test items? Choose Always Hidden if test security is critical use Hide Prior to Grading to hide until all students submit. Use sub-options to allow teachers to grade manually gradable items with the help of rubric while keeping the question hidden."
              premium
              placement="rightTop"
              id="content-visibility-tooltip"
            />
            <StyledRow gutter={16} mb="15px">
              <Col span={10}>
                <Label>{i18translate('contentVisibility.title')}</Label>
              </Col>
              <Col span={14}>
                <ContentVisibilityOptions
                  assignFlow
                  isDisabled={freezeSettings}
                  testContentVisibility={testContentVisibility}
                  isTestContentRestrictedBySuperAdmin={
                    isTestContentRestrictedBySuperAdmin
                  }
                  updateTestContentVisibility={(value) =>
                    overRideSettings(TEST_CONTENT_VISIBILITY, value)
                  }
                />
              </Col>
            </StyledRow>
          </SettingContainer>
        )}
      {/* Test Content visibility */}
      {COMMON.includes(testType) && (
        <SettingContainer
          id="allow-teachers-to-redirect"
          tooltipId="allow-teachers-to-redirect-tooltip"
        >
          <DetailsTooltip
            width={tootltipWidth}
            title="ALLOW TEACHERS TO REDIRECT"
            content={i18translate('allowTeacherToRedirect.info')}
            premium={premium}
            placement="rightTop"
            id="allow-teachers-to-redirect-tooltip"
          />
          <StyledRow
            data-cy="allow-teachers-to-redirect"
            gutter={16}
            mb="15px"
            height="40"
            noWrap
          >
            <Col span={10}>
              <Label>
                <span>ALLOW TEACHERS TO REDIRECT</span>
                <DollarPremiumSymbol premium={premium} />
              </Label>
            </Col>
            <Col span={10} style={{ display: 'flex', flexDirection: 'column' }}>
              <Row style={{ display: 'flex', alignItems: 'center' }}>
                <AlignSwitchRight
                  data-testid="allow-teachers-to-redirect-switch"
                  size="small"
                  defaultChecked
                  disabled={freezeSettings || !premium}
                  checked={allowTeacherRedirect}
                  onChange={(value) =>
                    overRideSettings('allowTeacherRedirect', value)
                  }
                  aria-label="Allow teachers to redirect"
                />
              </Row>
            </Col>
          </StyledRow>
        </SettingContainer>
      )}

      {/* Answer on Paper */}
      <SettingContainer
        id="answer-on-paper-setting"
        tooltipId="answer-on-paper-setting-tooltip"
      >
        <DetailsTooltip
          width={tootltipWidth}
          title="ANSWER ON PAPER"
          content=" Use this option if students will be taking the assessment on paper. When ON, teachers must manually enter paper-based responses after the assessment is closed. Students who do not submit electronically, will NOT be marked as absent."
          placement="rightBottom"
          premium={assessmentSuperPowersAnswerOnPaper}
          id="answer-on-paper-setting-tooltip"
        />
        <StyledRow gutter={16} mb="15p" noWrap>
          <Col span={10}>
            <Label>ANSWER ON PAPER</Label>
          </Col>
          <Col span={14}>
            <Tooltip
              title={
                isSectionAdaptiveTest
                  ? i18translate('notSupportedForSectionsAdaptiveTest.info')
                  : null
              }
            >
              <AlignSwitchRight
                disabled={
                  disableAnswerOnPaper ||
                  freezeSettings ||
                  !assessmentSuperPowersAnswerOnPaper ||
                  isSectionAdaptiveTest
                }
                size="small"
                checked={answerOnPaper}
                onChange={(value) => overRideSettings('answerOnPaper', value)}
                data-cy="ans-on-paper"
                aria-label="Answer on Paper"
              />
            </Tooltip>
          </Col>
        </StyledRow>
      </SettingContainer>
      {/* Answer on Paper */}

      {/* Choose Test Interface */}
      {(assignmentSettings?.testType || testSettings.testType) !== 'testlet' &&
        !testSettings.isDocBased && (
          <SettingContainer
            id="player-skin-setting"
            tooltipId="player-skin-setting-tooltip"
          >
            <DetailsTooltip
              width={tootltipWidth}
              title="Test Interface"
              content={`Teachers can change the look and feel of the assessments to more closely align with formats similar to state and nationally administered assessments. If you don’t see your state, select the generic option, ${
                isPearDomain ? pearAssessmentText : edulasticText
              } Test.`}
              premium={selectPlayerSkinType}
              placement="rightTop"
              id="player-skin-setting-tooltip"
            />
            <PlayerSkinSelector
              userRole={userRole}
              playerSkinType={playerSkinType}
              onAssignmentTypeChange={changeField('playerSkinType')}
              testType={assignmentSettings?.testType || testSettings.testType}
              selectBackgroundWhite
              disabled={freezeSettings || !selectPlayerSkinType}
              districtState={districtState}
              fullwidth
              userTestTypesInternal={userTestTypesInternal}
            />
          </SettingContainer>
        )}
      {/* Choose Test Interface */}
    </>
  )
}

const enhance = compose(
  withNamespaces('author'),
  connect((state) => ({
    userTestTypesInternal: getUserTestTypes(state),
    allTestTypesInternal: getTestTypesFormatedConstant(state),
    districtState: getCurrentSchoolState(state),
  }))
)

export default enhance(TestBehaviorGroupContainer)

const StyledSpan = styled.span`
  font-weight: ${(props) => props.theme.semiBold};
  font-size: 11px;
`
